module.exports = __webpack_public_path__ + "static/img/tu1.fa34115.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/element/tu1.png
// module id = b6Vg
// module chunks = 5